import { IconProps } from "./";
import Icon from "./assets/unchecked_24.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon24Unchecked(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} />;
}
